<script>
    import { clearStatsCache, downloadGames, loadFull, loadAllCampaigns, downloadIndividualGame, ensureGameDetails, hasFullStateToLoad } from "./net";
    import { clone, state, res, resetStores, ui, findCard, findCardByName } from './stores.js';
    import Average from './Average.svelte';
    import { convert } from './ui.js';
    import { Tabs, Tab, TabList, TabPanel } from 'svelte-tabs';
    import LogCard from "./LogCard.svelte";
    import CampaignSummary from './CampaignSummary.svelte';
    import { allActions, allTokenTypes, possArray } from "./card_actions";
    import ActionBit from "./ActionBit.svelte";
    import BotLog from './BotLog.svelte';
    import ScoreChart from './ScoreChart.svelte';
    import { decompress, gameURL } from "./save";
    import Log from "./Log.svelte";
    import { makeReadyForPlay } from "./game";
    import Preview from "./Preview.svelte";
    import { copyURL } from "./save.js"; 
    import StatSummary from "./StatSummary.svelte";
    import download from "downloadjs";
    import ScoreAnalysis from "./ScoreAnalysis.svelte";
    import Select from "svelte-select/Select.svelte";

    export let providedGames = false;

    let games;
    let gamePage = 0;
    let showLog = false;
    let hidePractice = false;
    let showCharts = {};
    let savedGames = [];
    let cardFilter = false;
    let devCaptain = 'Picard';
    let devList = [];
    let filtered = [];
    let captainFilter = false;
    let boxFilter = [];
    let userFilter = false;
    let dateFilter = false;

    export let gameKey = false;

    let humanCaptains;
    let botCaptains;

    $: games = filterGames(games, gameKey, hidePractice, captainFilter, boxFilter);

    function filterGames(games, gameKey, hidePractice){
        //console.log('filtering', games, savedGames, gameKey, hidePractice)
        if(gameKey && games){
            games = savedGames.filter(g => g.key == gameKey);
        }else if(hidePractice){
            console.log('filtering', savedGames, savedGames.filter(g => !g.practice));
            games = savedGames.filter(g => !g.practice);
        }else if(savedGames.length > 0){
            games = savedGames;
        }else{
            games = [];
        }
        if(captainFilter){  
            if(captainFilter.wave){
                // As long as some captain from that set is in the game then it counts
                // But excludes future waves
                games = games.filter(g => g.players.some(p => captainFilter.captains.some(c => p.captain == c)))
                console.log(`before wave exclusion: ${games.length} games`)
                let excludedGames = games.filter(g => g.players.some(p => !currentWaves(captainFilter.wave).some(c => p.captain == c)));
                games = games.filter(g => !g.players.some(p => !currentWaves(captainFilter.wave).some(c => p.captain == c)));
                console.log(`after wave exclusion: ${games.length} games`)
                console.log('excluded games:', excludedGames);
            }else{
                games = games.filter(g => g.players.some(p => p.captain == captainFilter))
            }
            
        }
        if(boxFilter && boxFilter.length > 0){
            let commonPrefixes = ['PER','CAR','SHI','ALL','LOC','ENC','INC'];
            let refs = $res.sets.filter(s => boxFilter.includes(s.name)).map(s => s.ref)
            // Games listed from PocketBase carry boxRefs instead of cards[] until their details load
            games = games.filter(g => g.cards
                ? g.cards.some(c => c && c.id && commonPrefixes.some(p => refs.some(r => c.id.startsWith(`${r}${p}`))))
                : (g.boxRefs || []).some(b => refs.some(r => String(r) == b)));
            
        }
        if(userFilter){
            games = games.filter(g => g.players.some(p => p.username == userFilter))
        }
        if(dateFilter){
            let date = new Date(`Jan 1, ${dateFilter}`);
            games = games.filter(g => g.startDate >= date.valueOf())
        }
        games = [...games].sort((a,b) => b.endDate - a.endDate); // sorted once here rather than on every render of the game list

        cardAnalysis.done = false;
        caps = clone(origCaps);

        setBotLevels(games);

        countUsers(games);

        //humanCaptains = captains(games, 'no bot');
        //botCaptains = captains(games, 'bot');
        return games;
    }

    let botLevels = [];
    let chosenLevel = false;

    function setBotLevels(games){
        for(let g of games){
            for(let p of g.players){
                if(!p.bot) continue;
                if(p.botLevel && !botLevels.includes(p.botLevel)){
                    botLevels.push(p.botLevel);
                }
            }
        }
        chosenLevel = -1; //botLevels[0];
    }

    async function getStats(all = false){
        if(gameKey){
            savedGames = await downloadIndividualGame(gameKey);
        }else if(providedGames){
            savedGames = providedGames;
        }else{
            savedGames = await downloadGames(); // cached in net.js across mounts of this tab
        }
        games = savedGames;
        filterGames(games, gameKey, hidePractice);
    }

    let reloading = false;

    async function refresh(){
        clearStatsCache();
        reloading = true;
        await getStats();
        reloading = false;
    }

    function actions(p){
        let a = {};
        let l = {};
        if(!p.stats || !p.stats.turns) return [];
        for(let t of p.stats.turns){
            if(!t) continue;
            for(let k of Object.keys(t)){
                if(!a[k]) a[k] = 0;
                if(!l[k]) l[k] = [];
                l[k] = [...l[k], t[k]]
                a[k] += t[k];
            }
        }
        let list = [];
        for(let k of Object.keys(a)){
            list.push({
                name: k,
                num: a[k],
                list: l[k]
            });
        }
        return list;
    }

    function consolidateActions(stats, turns){
        let con = {};
        if(!stats || !stats.turns) return [];
        for(let turn of Object.keys(stats.turns)){
            let t = stats.turns[turn];
            for(let k of Object.keys(t)){
                let a = allActions.filter(a => a.listAs).find(a => a.type == k && a.listAs);
                if(a){
                    a = a.listAs;
                }else{
                    a = allActions.filter(a => a.listAs).find(a => a.listAs[k]);
                    if(a) a = a[k]
                }
                if(!a) [k];
                if(!a) continue;

                if(!con[a]){
                    con[a] = {
                        sum: 0,
                        byTurn: Array(turns)
                    };
                    
                }
                con[a].byTurn[parseInt(turn)] = t[k];
                con[a].sum += t[k];
            }
        }
        return Object.keys(con).map(k => {return {name: k, count: con[k].sum, byTurn: con[k].byTurn}}).sort((a,b) => b.count - a.count);
    }

    function currentWaves(w){
        let content = [];
        for(let k of Object.keys(captainsByWave)){
            if(k <= w) content.push(...captainsByWave[k]);
        }
        return content;
    }

    function viewLog(g){
        console.log(g);
        $state = decompress(g.fullState);
        console.log($state);
        showLog = true;
    }

    function playAgain(g){
        let replayInfo = decompress(g.replayInfo);
        $state = replayInfo.initialState;
        $res.initialState = clone($state);
        $ui.tab = 'game';
    }

    function getCards(g, p){
        return p.cards.map(c => g.cards.find(cd => cd.id == c)).filter(c => c).sort((a,b) => byPlayCount(a,b))
    }
    
    function byPlayCount(a,b){
        let aCount = 0;
        let bCount = 0;
        if(a.stats){
            aCount += a.stats.play || 0;
            aCount += a.stats.activate || 0;
            aCount += a.stats.reaction || 0;
            aCount += a.stats.complete || 0;
            aCount += a.stats.control || 0;
        }
        if(b.stats){
            bCount += b.stats.play || 0;
            bCount += b.stats.activate || 0;
            bCount += b.stats.reaction || 0;
            aCount += b.stats.complete || 0;
            aCount += b.stats.control || 0;
        }
        return bCount - aCount;
    }

    function divvyCardTypes(p, cards){
        // Returns {name, group} where group is an array of three bits
        let categories = [
            {
                name: 'Market cards',
                group: []
            },
            {
                name: 'Encounters',
                group: []
            },
            {
                name: 'Completed missions',
                group: []
            },
            {
                name: 'Deck cards',
                group: []
            },
            {
                name: 'Common locations',
                group: []
            },
            {
                name: 'Incidents',
                group: []
            },
            {
                name: 'Other',
                group: []
            }
        ]
        for(let c of cards){
            if($res.cards.find(cd => cd.id == c.id)){
                c = {...$res.cards.find(cd => cd.id == c.id), score: 0, ...c};
            }else if($res.cards.find(cd => cd.name == c.name)){
                c = {...$res.cards.filter(c => c.deck == 'Common' || c.deck == 'Locations' || c.deck == p.captain).find(cd => cd.name == c.name), score: 0, ...c};
            }else{
                //console.log('card no longer in database, so cannot categorise it for score', c);
            }
            if(!c.suits || c.suits.includes('mission')){
                if(c.complete && !c.dashMission) categories.find(t => t.name == 'Completed missions').group.push(c);
            }else if(c.suits.includes('encounter')){
                categories.find(t => t.name == 'Encounters').group.push(c);
            }else if(c.suits.includes('incident')){
                categories.find(t => t.name == 'Incidents').group.push(c);
            }else if(c.deck == 'Common'){
                categories.find(t => t.name == 'Market cards').group.push(c);
            }else if(c.deck == p.captain){
                categories.find(t => t.name == 'Deck cards').group.push(c);
            }else if(c.deck == 'Locations'){
                categories.find(t => t.name == 'Common locations').group.push(c);
            }else{
                categories.find(t => t.name == 'Other').group.push(c);
            }
        }

        let flatVP = 0;

        for(let g of categories){
            let flat = [];
            let mult = [];
            let cond = [];
            for(let c of g.group){
                if(c.stripe && c.stripe.length > 0){
                    mult.push(c);
                }else if(c.vp || !isNaN(c.vp) || c.complete){
                    flat.push(c);
                    if(c.score && !c.hasOwnProperty('endGameScore') && (!c.goal || !c.goal.includes('Endgame'))){
                        flatVP += (c.score || 0);
                    }else{
                        flatVP += (c.vp || 0);
                    }
                    
                }
                if(c.goal && c.goal.includes('Endgame:') || c.hasOwnProperty('endGameScore')){
                    let copy = {...c};
                    if(c.hasOwnProperty('endGameScore')){
                        copy.score = c.endGameScore;
                    }else if(c.id && p.scoreBreakdown.endGameSpecific.hasOwnProperty(c.id.replaceAll(`/`, `_`))){
                        copy.score = p.scoreBreakdown.endGameSpecific[c.id.replaceAll(`/`, `_`)] + (c.vp || 0); // fixing missing info in upload
                    }else{
                        console.log('unable to find endgame score', c, p.scoreBreakdown.endGameSpecific);
                    }
                    cond.push(copy);
                }
            }
            g.group = {
                flat,
                multiplier: mult,
                conditional: cond
            }
        }
        p.flatVP = flatVP;
        return categories;
    }

    function matchesCard(c, filter){
        if(!filter) return true;
        if(filter == 'Encounters') return c.suits && c.suits.includes('encounter');
        if(filter == 'Incidents') return c.suits && c.suits.includes('incident');
        return c.deck == filter && !c.suits.includes('encounter') && !c.suits.includes('incident');
    }

    async function replay(g){
        let replayInfo = decompress(g.replayInfo);
        $state = replayInfo.initialState;
        $res.deltas = replayInfo.deltas;
        $res.initialState = clone($state);
        $res.replaying = true;
        $res.nextDelta = 0;
        console.log($state);
        await makeReadyForPlay();
        $ui.tab = 'game';
    }

    let users = {};

    let cardAnalysis = {
        done: false,
        locations:{
            taken: {

            },
            appeared: {

            },
            byPopularity: []
        },
        market: {
            taken: {

            },
            appeared: {

            },
            byPopularity: []
        },
        devs: {
            entered: {

            },
            byTime: []
        },
        plays: {
            count: {

            },
            byMost: []
        },
        activations: {
            count: {

            },
            byMost: []
        },
        reactions: {
            count: {

            },
            byMost: []
        },
        choices: {

        },
        numGames: {},
        summary: []
    };
    
    function addStat(stat, card, inc = 1){
        if(!stat[card]) stat[card] = 0;
        stat[card] += inc;
    }

    function addStatList(stat, card, element){
        if(!stat[card]) stat[card] = [];
        stat[card].push(element);
    }

    function analyseCards(games){
        if(cardAnalysis.done) return cardAnalysis; // To avoid recalculating every time (reset on filter etc.)
        let cardMap = {};
        for(let g of games){
            for(let c of g.cards){
                let origC = cardMap[c.id] || findCard($res.cards, c.id);
                if(!origC) origC = findCardByName($res.cards, c.name);
                if(!origC){
                    //console.log('Card no longer in database', c);
                    continue;
                }
                cardMap[c.id] = origC; // Cache for future
                if(c.entered && Object.keys(c.entered).length > 0){
                    addStat(cardAnalysis.numGames, c.id); // It entered play in a game
                }
                if(origC.deck == 'Locations'){
                    // Location analysis
                    if(c.entered && Object.keys(c.entered).length > 0){
                        addStat(cardAnalysis.locations.appeared, c.id);
                    }
                    /*if(c.stats && c.stats.control){
                        addStat(cardAnalysis.locations.taken, c.id);
                    }*/
                    
                    if(c.left && c.left.location && c.left.location != 'junk'){
                        // This means it was taken, right?
                        //console.log(c.id, cardAnalysis.locations.taken[c.id], c.left)
                        addStat(cardAnalysis.locations.taken, c.id);
                    }
                }
                if(origC.deck == 'Common' && !origC.suits.some(s => s == 'incident' || s == 'encounter')){
                    if(c.entered && Object.keys(c.entered).length > 0){
                        //if(origC.name == 'Aeon') console.log('Aeon appeared', cardAnalysis.market.appeared[c.id]);
                        addStat(cardAnalysis.market.appeared, c.id);
                        //if(origC.name == 'Aeon') console.log(`Aeon (${c.id}) appeared`, cardAnalysis.market.appeared[c.id]);
                    }
                    
                    if(c.left && c.left.location && c.left.location != 'junk'){
                        // This means it was taken, right?
                        //console.log(c.id, cardAnalysis.locations.taken[c.id], c.left)
                        addStat(cardAnalysis.market.taken, c.id);
                        //if(origC.name == 'Aeon') console.log(`Aeon (${c.id}) taken`, cardAnalysis.market.taken[c.id]);
                    }
                }
                if(origC.area == 'Development'){
                    if(c.entered && c.entered.turn){
                        addStatList(cardAnalysis.devs.entered, c.id, c.entered.turn);
                        //if(!cardAnalysis.devs.entered[c.id]) cardAnalysis.devs.entered[c.id] = [];
                        //cardAnalysis.devs.entered[c.id].push(c.entered.turn);
                    }
                }
                if(c.stats){
                    if(c.stats.play || c.stats.freeplay){
                        addStatList(cardAnalysis.plays.count, c.id, (c.stats.play || 0) + (c.stats.freeplay || 0));
                    }
                    if(c.stats.activate){
                        addStatList(cardAnalysis.activations.count, c.id, c.stats.activate);
                    }
                    if(c.stats.reaction){
                        addStatList(cardAnalysis.reactions.count, c.id, c.stats.reaction);
                    }
                }
                
                if(c.chosenOptions && Object.keys(c.chosenOptions).length > 0){
                    if(!cardAnalysis.choices[c.id]) cardAnalysis.choices[c.id] = {};
                    //console.log('options', c.chosenOptions)
                    for(let o of Object.keys(c.chosenOptions)){
                        addStat(cardAnalysis.choices[c.id], o, c.chosenOptions[o]);
                    }
                }
            }
        }

        // Now produce summaries etc.
        for(let id of Object.keys(cardAnalysis.locations.appeared)){
            let s = {
                card: cardMap[id],
                popularity: (cardAnalysis.locations.taken[id] || 0) / cardAnalysis.locations.appeared[id],
                popularityString: `${cardAnalysis.locations.taken[id] || 0}/${cardAnalysis.locations.appeared[id]}`//(cardAnalysis.locations.taken[id] || 0) / cardAnalysis.locations.appeared[id]
            };
            /*if(isNaN(s.popularity)){
                console.log('NaN', cardMap[id], cardAnalysis.locations.appeared[id], cardAnalysis.locations.taken[id])
            }*/
            if(cardAnalysis.locations.byPopularity.some(c => c.card.name == s.card.name)){
                //console.log('combining multiple cards with same name: '+s.card.name)
                let c = cardAnalysis.locations.byPopularity.find(c => c.card.name == s.card.name);
                c.popularity = c.taken / c.appeared;
                c.popularityString = `${c.taken}/${c.appeared}`;
            }else{
                cardAnalysis.market.byPopularity.push(s);
            }  
            cardAnalysis.locations.byPopularity.push(s);
        }

        for(let id  of Object.keys(cardAnalysis.devs.entered)){
            let avg = cardAnalysis.devs.entered[id].reduce((a,i) => a+i, 0) / cardAnalysis.devs.entered[id].length
            let s = {
                card: cardMap[id],
                entered: cardAnalysis.devs.entered[id].length,
                sum: cardAnalysis.devs.entered[id].reduce((a,i) => a+i, 0),
                avg,
                avgString: `${avg.toFixed(1)}/${cardAnalysis.devs.entered[id].length}`
            };
            if(cardAnalysis.devs.byTime.some(c => c.card.name == s.card.name)){
                //console.log('combining multiple cards with same name: '+s.card.name)
                let c = cardAnalysis.devs.byTime.find(c => c.card.name == s.card.name);
                c.sum += s.sum;
                c.entered += s.entered;
                c.avg = c.sum / c.entered;
                c.avgString = `${c.avg.toFixed(1)}/${c.entered}`;
            }else{
                cardAnalysis.devs.byTime.push(s);
            }      
        }

        for(let id of Object.keys(cardAnalysis.plays.count)){
            let avg = cardAnalysis.plays.count[id].reduce((a,i) => a+i, 0) / cardAnalysis.plays.count[id].length;
            let s = {
                card: cardMap[id],
                avg,
                avgString: `${avg.toFixed(1)}/${cardAnalysis.plays.count[id].length}`
            }
            cardAnalysis.plays.byMost.push(s);
        }

        for(let id of Object.keys(cardAnalysis.activations.count)){
            let avg = cardAnalysis.activations.count[id].reduce((a,i) => a+i, 0) / cardAnalysis.activations.count[id].length;
            let s = {
                card: cardMap[id],
                avg,
                avgString: `${avg.toFixed(1)}/${cardAnalysis.activations.count[id].length}`
            }
            cardAnalysis.activations.byMost.push(s);
        }

        for(let id of Object.keys(cardAnalysis.reactions.count)){
            let avg = cardAnalysis.reactions.count[id].reduce((a,i) => a+i, 0) / cardAnalysis.reactions.count[id].length;
            let s = {
                card: cardMap[id],
                avg,
                avgString: `${avg.toFixed(1)}/${cardAnalysis.reactions.count[id].length}`
            }
            cardAnalysis.reactions.byMost.push(s);
        }

        for(let id of Object.keys(cardAnalysis.market.appeared)){
            let s = {
                card: cardMap[id],
                taken: cardAnalysis.market.taken[id] || 0,
                appeared: cardAnalysis.market.appeared[id],
                popularity: (cardAnalysis.market.taken[id] || 0) / cardAnalysis.market.appeared[id],
                popularityString: `${cardAnalysis.market.taken[id] || 0}/${cardAnalysis.market.appeared[id]}`//(cardAnalysis.locations.taken[id] || 0) / cardAnalysis.locations.appeared[id]
            };

            if(cardAnalysis.market.byPopularity.some(c => c.card.name == s.card.name)){
                //console.log('combining multiple cards with same name: '+s.card.name)
                let c = cardAnalysis.market.byPopularity.find(c => c.card.name == s.card.name);
                c.taken += s.taken;
                c.appeared += s.appeared;
                c.popularity = c.taken / c.appeared;
                c.popularityString = `${c.taken}/${c.appeared}`;
            }else{
                cardAnalysis.market.byPopularity.push(s);
            }  
        }

        for(let id of Object.keys(cardMap)){
            //console.log(cardMap[id]);
            let s = {
                card: cardMap[id],
                numGames: cardAnalysis.numGames[id]
            };
            if(cardAnalysis.choices[id]) s.choices = cardAnalysis.choices[id];
            cardAnalysis.summary.push(s);
        }

        cardAnalysis.locations.byPopularity = cardAnalysis.locations.byPopularity.sort((a,b) => b.popularity - a.popularity)
        cardAnalysis.market.byPopularity = cardAnalysis.market.byPopularity.sort((a,b) => b.popularity - a.popularity)
        cardAnalysis.devs.byTime = cardAnalysis.devs.byTime.sort((a,b) => a.avg - b.avg);
        devList = cardAnalysis.devs.byTime;
        cardAnalysis.plays.byMost = cardAnalysis.plays.byMost.sort((a,b) => b.avg - a.avg);
        cardAnalysis.activations.byMost = cardAnalysis.activations.byMost.sort((a,b) => b.avg - a.avg);
        cardAnalysis.reactions.byMost = cardAnalysis.reactions.byMost.sort((a,b) => b.avg - a.avg);

        cardAnalysis.done = true;
        return cardAnalysis;
    }

    let origCaps = {
        "bot": {
            done: false,
            value: {}
        },
        "no bot": {
            done: false,
            value: {}
        },
        "all": {
            done: false,
            value: {}
        }
        
    }

    let caps = clone(origCaps);

    function countUsers(games){
        users = {};
        for(let g of games){
            let alreadyThereUsers = [];
            for(let p of g.players){
                if(p.username && !alreadyThereUsers.includes(p.username)){
                    if(!users[p.username]) users[p.username] = 0;
                    users[p.username]++;
                    alreadyThereUsers.push(p.username);
                }
            }
            
        }
    }

    function captains(games, bot = 'all', botLevel = false){
        if(caps[bot].done) return caps[bot].value;
        let c = {};
        for(let g of games){
            let alreadyThereUsers = [];
            let i = -1;
            for(let p of g.players){
                i++;
                //if(p.bot) console.log('bot', p.botLevel);
                if(g.practice && i == 1) continue;
                if(bot != 'all'){
                    //console.log(bot, p.bot)
                    if(bot == 'bot' && !p.bot){
                        //console.log('skipping non-bot');
                        continue;
                    }else if(bot == 'bot' && !p.botLevel && botLevel && botLevel != -1){ // for pre-level ones
                        //console.log('skipping wrong level');
                        continue;
                    }else if(bot == 'bot' && p.botLevel && p.botLevel != botLevel && botLevel != -1){
                        //console.log('skipping wrong level');
                        continue;
                    }else if (bot != 'bot' && p.bot){
                        //console.log('skipping bot');
                        continue;
                    }
                }
                
                if(!c.hasOwnProperty(p.captain)){
                    c[p.captain] = {
                        name: p.captain,
                        played: 0,
                        wins: 0,
                        losses: 0,
                        draws: 0,
                        turns: [],
                        score: [],
                        gained: {},
                        burns: 0,
                        decksize: []
                    }
                }
                c[p.captain].played++;
                if(!g.winners){
                    c[p.captain].draws++;
                }else if(g.winners.includes(p.captain)){
                    c[p.captain].wins++;
                }else{
                    c[p.captain].losses++;
                }
                if(g.gameEndTrigger == 'Burn'){
                    if(!c[p.captain].burn) c[p.captain].burn = 0;
                    c[p.captain].burn++;
                }
                if(p.cardCounts){
                    c[p.captain].decksize.push(p.cardCounts.deck)
                }
                if(p.stats && p.stats.cardsGained){
                    for(let k of Object.keys(p.stats.cardsGained)){
                        if(!c[p.captain].gained[k]) c[p.captain].gained[k] = [];
                        c[p.captain].gained[k].push(p.stats.cardsGained[k]);
                    }
                }
                for(let t of [...allTokenTypes(), ...$res.trackTypes, 'collective', 'treachery']){
                    if(!c[p.captain][t]) c[p.captain][t] = [];
                    if(typeof p[t] == 'number') c[p.captain][t].push(p[t]);
                }
                if(g.turns) c[p.captain].turns.push(g.turns);
                if(!isNaN(p.score)) c[p.captain].score.push(p.score);
            }
        }
        caps[bot].value = Object.values(c).sort((a, b) => a.name.localeCompare(b.name));
        if(bot != 'bot') caps[bot].done = true; // Bots keep updating because of level
        return caps[bot].value;
    }

    function gamePages(games){
        let pages = [0];
        let nextPage = 50;
        while(nextPage < games.length){
            pages.push(nextPage);
            nextPage += 50;
        }
        return pages;
    }

    function pagedGames(games, gamePage){
        return games.slice(gamePage, gamePage+50); // already sorted by filterGames
    }

    function exportUserGamesList(){
        // Dumping name/date pairs as a CSV per game
        let list = [];
        for(let g of games){
            let item = {
                Date: new Date(g.startDate).toDateString(),
                User: g.players[0].username,
                'Captain 1': g.players[0].captain,
                'Captain 1 score': g.players[0].score,
                'Captain 2': g.players[1].captain,
                'Captain 2 score': g.players[1].score,
                Turns: g.turns || 'unrecorded',
                Notes: ''
            }
            list = [...list, item];
            if(g.players[1].username != g.players[0].username){
                list = [...list, {...item, User: g.players[1].username, Notes: 'Copy of above game: second player was a different user'}]
            }
        }
        if(list.length == 0){
            alert('No items in games list to export!');
            return;
        }
        let csv = [
            Object.keys(list[0]).join(',')
        ];
        for(let l of list){
            csv = [...csv, Object.values(l).join(', ')];
        }
        csv = csv.join('\n');
        download(new Blob([csv]), 'gameslist.csv', 'text/csv');
    }

    async function exportAllGames(){
        await ensureGameDetails(games);
        download(new Blob([JSON.stringify(games)]), 'stcc_games.json', 'application.json');
    }

    let captainsByWave = {
        1: ['Picard', 'Sisko', 'Sela', 'Burnham', 'Koloth', 'Shran'],
        2: ['Georgiou', 'Archer', 'Khan', 'Kirk', 'Rebner', 'Soval', 'Freeman', 'Pike', 'Riker'],
        3: ['Borg Queen', 'Q', 'Dal & Gwyn', 'Janeway', 'Boimler', 'Shaw', 'Worf', 'Eddington', 'Dukat', 'Cullah']
    }
</script>

{#await getStats()}
    Loading games...
{:then}
    {#if gameKey}
        <div>
            Showing specific game <button on:click={e => {gameKey = false; getStats();}}>Reset</button>
        </div>
    {:else}
        {games.length} games uploaded so far.
        <button on:click={refresh} disabled={reloading}>{reloading ? 'Refreshing…' : 'Refresh from server'}</button>
        <div>
            <input type="checkbox" bind:checked={hidePractice} /> Hide practice games?
        </div>
        Filter games by captain:
        <select bind:value={captainFilter} on:change={e => {games = filterGames(games, gameKey, hidePractice, captainFilter, boxFilter, userFilter);}}>
            <option value={false}>All captains</option>
            {#each captains(savedGames, 'all') as c}
                <option value={c.name}>{c.name}</option>
            {/each}
            {#each Object.keys(captainsByWave) as w}
                <option value={{wave: w, captains: captainsByWave[w]}}>Any of wave {w} captains</option>
            {/each}
        </select>
        Filter games by box:
        <!--<select multiple bind:value={boxFilter} on:change={e => {games = filterGames(games, gameKey, hidePractice, captainFilter, boxFilter, userFilter);}}>
            <option value={false}>All boxes</option>
            {#each $res.sets as s}
                <option value={s}>{s.name}</option>
            {/each}
        </select>-->
        <div class="multiselect"><Select containerStyles="color: black;" bind:value={boxFilter} items={$res.sets.map(s => s.name)} multiple={true} clearable={true} on:clear={e => {games = filterGames(games, gameKey, hidePractice, captainFilter, boxFilter, userFilter);}} on:change={e => {games = filterGames(games, gameKey, hidePractice, captainFilter, boxFilter, userFilter);}}/></div>

        Filter games by user:
        <select bind:value={userFilter} on:change={e => {games = filterGames(games, gameKey, hidePractice, captainFilter, boxFilter, userFilter);}}>
            <option value={false}>All boxes</option>
            {#each (users ? Object.keys(users) : []) as u}
                <option value={u}>{u}</option>
            {/each}
        </select>

        Filter games by year: <input type="number" bind:value={dateFilter} on:change={e => {games = filterGames(games, gameKey, hidePractice, captainFilter, boxFilter, dateFilter);}}>
        Export all games (as big JSON file!): <button on:click={exportAllGames}>Download</button>
    {/if}
    <div class="pane">
        <Tabs initialSelectedIndex={gameKey ? 1 : 0}>
            <TabList>
                <Tab>Summary</Tab>
                <Tab>Games</Tab>
                <Tab>Campaigns</Tab>
                <Tab>Cards</Tab>
            </TabList>
        <TabPanel>
            <h2>Summary</h2>
            <p>
                Human captains:
                <StatSummary {games} bot={false} capFunc={captains} />
            </p>
            <p>
                Bots:
                <select bind:value={chosenLevel}>
                        <option value={false}>(No level)</option>
                        <option value={-1}>All levels aggregated</option>
                    {#each botLevels as l}
                        <option value={l}>{l}</option>
                    {/each}
                </select>
                <StatSummary {games} bot={chosenLevel} capFunc={captains} />
            </p>
            <p>
                Users:
                <button on:click={exportUserGamesList}>Export data as CSV</button>
            </p>
            <table>
                <tr>
                    <th>Username</th><th>Games</th>
                </tr>
                {#each Object.keys(users).sort((a,b) => users[b] - users[a]) as k}
                    <tr>
                        <td>{k}</td>
                        <td>{users[k]}</td>
                    </tr>
                {/each}
            </table>
         </TabPanel>
         <TabPanel>
            <h2>Game list</h2>
            {#if games.length > 50}
                <div>
                    {#each gamePages(games) as p}
                        <a style="cursor: pointer; font-size: 3vmin; font-weight: bold; {gamePage == p ? 'color: orange;' : 'color: blue;'}" on:click={e => {gamePage = p}} >{p+1}–{p+50 > games.length ? games.length : p+50}</a>&nbsp;
                    {/each}
                </div>
            {/if}
            {#await ensureGameDetails(pagedGames(games, gamePage))}
                Loading game details...
            {:then}
            {#each pagedGames(games, gamePage) as g}
                    <div class="title">
                        {@html convert(g.players.filter((p,i) => i == 0 || !g.practice).map(p => `${p.captain} (${p.score}) ${p.bot ? '&nbsp;🤖' : ''}`).join(' v '))}
                    </div>
                    <div class="basicinfo" on:click={e => {console.log(g);}}>
                        {#if g.hostUsername}
                            <div>
                                Hosted by {g.hostUsername}{#if g.endDate}, game completed {new Date(g.endDate).toLocaleString()}{/if}
                            </div>
                        {/if}
                        {#if g.campaign}
                            <div>
                                Game {g.campaignInfo.games.length} of a campaign: played as rank {g.campaignInfo.currentRank}
                            </div>
                        {/if}
                        {#if g.practice}
                            <div><b>Cadet mode</b></div>
                        {/if}
                        {#if g.winners}
                            <div>
                                Winner(s): {g.winners}
                            </div>
                        {:else}
                            <div>
                                Draw
                            </div>
                        {/if}
                        {#if g.turns}
                            <div>
                                {g.turns} turns
                            </div>
                        {/if}
                        {#if g.gameEndTrigger}
                            <div>
                                Game ended by {g.gameEndTrigger}
                            </div>
                        {/if}
                        {#if g.campaign}
                            <div>
                                Campaign reward: 
                                {#if g.reward}
                                    {#if g.reward.card}
                                        added 
                                        {#each possArray(g.reward.card) as card}
                                            <LogCard showFinalScores textSize=2 c={findCard($res.cards, card.id)} />
                                        {/each}
                                        from {g.reward.type == 'add_reserve' ? 'Reserve/Available' : 'Commons'}
                                    {:else if g.reward.type == 'gain_track'}
                                        gained {g.reward.amount}
                                        {#if g.won}
                                            on all tracks
                                        {:else}
                                            {@html convert(`[[${g.reward.track}]]`, true)}
                                        {/if}
                                    {:else if g.reward.type == 'upgrade_reinforce'}
                                        upgraded *Reinforce*
                                    {/if}
                                {:else}
                                    none taken
                                {/if}
                            </div>
                        {/if}
                        <div>
                            <button on:click={e => {copyURL(gameURL(g))}}>Share game URL</button>
                            {#if g.fullState}
                                    <button on:click={e => {viewLog(g)}}>View log</button>
                                    {#if g.replayInfo}
                                        <button on:click={e => {playAgain(g)}}>Play this setup</button>
                                        <button on:click={e => {replay(g)}}>Replay game as observer</button>
                                    {/if}
                            {:else if g.loading}
                                Loading full state...
                            {:else if hasFullStateToLoad(g)}
                                <button on:click={async (e) => {g.loading = true; await loadFull(g); g.loading = false; }}>Download full state (to view logs, replay, etc.)</button>
                            {/if}
                        </div>
                    </div>
                    
                    {#if showCharts[g.key]}
                        <ScoreChart game={g} />
                    {:else}
                        <button on:click={e => {showCharts[g.key] = true;}}>Show score chart</button>
                    {/if}
                    <div>
                        <details>
                            <summary>Market card statistics:</summary>
                            {#each g.cards.filter(c => (c.entered && c.entered.location == 'market') || (findCard($res.cards, c.id) && findCard($res.cards, c.id).deck == 'Common' && c.left && Object.keys(c.left).length > 0)) as c}
                                <div style="margin-left: 2vmin;">
                                    {#if findCard($res.cards, c.id)}
                                        <LogCard showFinalScores clickable showStats textSize=2 c={findCard($res.cards, c.id)} />
                                    {:else if findCardByName($res.cards, c.name)}
                                        <LogCard showFinalScores clickable showStats textSize=2 c={findCardByName($res.cards, c.name)} />
                                    {:else}
                                        {c.name} ({c.id})
                                    {/if}
                                    &rarr;
                                    {#if c.entered && c.entered.location == 'market' && c.entered.hasOwnProperty('turn')}
                                        entered market turn {c.entered.turn},
                                    {:else}
                                        never entered market, 
                                    {/if}
                                    {#if c.left && c.left.hasOwnProperty('turn')}
                                        went to {c.left.location} turn {c.left.turn} {#if c.entered && c.entered.location != 'market' && c.entered.location != 'junk'}(gained from top of deck){/if}
                                    {:else}
                                        never left market
                                    {/if}
                                </div>
                            {/each}
                        </details>
                    </div>
                    <div class="player_breakdown">
                        {#each g.players.filter((p, i) => !g.practice || i == 0) as p, i}
                            <ScoreAnalysis {p} cards={getCards(g, p)} />
                            <!--<div on:click={e => {console.log(p);}} class="player {p.captain.toLowerCase()}">
                                <div class="player_title">{p.captain}: {@html convert(`${p.score}`)}
                                    {#if p.bot}
                                        &nbsp;🤖 
                                        {#if p.botLevel}
                                            ({p.botLevel})
                                        {/if}
                                    {/if}
                                    {#if p.username}(played by {p.username}){/if}
                                </div>
                                <div>
                                    {#each $res.trackTypes as t}
                                        {#if p[t]}
                                            {p[t]}{@html convert(`[[${t}]]`, false)}&nbsp;
                                        {/if}
                                    {/each}
                                    {#each allTokenTypes() as t}
                                        {#if p[t]}
                                            {p[t]}{@html convert(`[[${t}]]`, false)}&nbsp;
                                        {/if}
                                    {/each}
                                </div>
                                <div class="line"></div>
                                {#if p.stats && p.stats.cardsGained}
                                    <div><div class="subtitle">Cards gained:</div>
                                        {#each Object.keys(p.stats.cardsGained) as k, i}
                                            {#if k == 'none'}
                                                No suit:
                                            {:else if k != 'redshirt'}
                                                {@html convert(`[[${k}]]`, true)}:
                                            {:else}
                                                {k}:
                                            {/if}
                                            {p.stats.cardsGained[k]}
                                            {#if i < Object.keys(p.stats.cardsGained).length - 1},&nbsp;{/if}
                                        {/each}
                                    </div>
                                    <div class="line"></div>
                                {/if}
                                {#if p.scoreBreakdown}
                                    {@const categories = divvyCardTypes(p, getCards(g, p))}
                                    <div>
                                        <div class="subtitle">Score breakdown:</div>
                                        {#if p.scoreBreakdown.hasOwnProperty('marked')}
                                            <div>Marked cards: {p.scoreBreakdown.marked}</div>
                                        {/if}
                                        {#if p.scoreBreakdown.hasOwnProperty('resources')}
                                            <div>Resources: {p.scoreBreakdown.resources}</div>
                                        {/if}
                                        <table>
                                            <tr>
                                                <th>Category</th><th>Flat VP ({p.flatVP || p.scoreBreakdown.cards} VP)</th><th>Multiplied ({p.scoreBreakdown.tracks} VP)</th><th>Endgame ({p.scoreBreakdown.endGame} VP)</th>
                                            </tr>
                                                {#each categories as set}
                                                    <tr>
                                                        <td>{set.name}</td>
                                                        {#each Object.keys(set.group) as k}
                                                            <td style="text-align: left;">
                                                                {#each set.group[k] as c}
                                                                    {#if $res.cards.find(cd => cd.id == c.id)}
                                                                        <LogCard showFinalScores showStats clickable category={k} textSize=2 c={{...$res.cards.find(cd => cd.id == c.id), score: 0, ...c}} />
                                                                    {:else if $res.cards.find(cd => cd.name == c.name)}
                                                                        (<LogCard showFinalScores showStats clickable category={k} textSize=2 c={{...$res.cards.find(cd => cd.name == c.name), score: 0, ...c}} />)
                                                                    {:else}
                                                                        {c.name} ({c.id} – no longer in master spreadsheet)
                                                                    {/if}
                                                                {/each}
                                                            </td>
                                                        {/each}
                                                    </tr>
                                                {/each}
                                        </table>
                                    </div>
                                    <div class="line"></div>
                                {/if}
                                <div class="action_list"><div class="subtitle">Actions taken:</div>
                                    {#each consolidateActions(p.stats, g.turns || 10) as a}
                                        <ActionBit {a} textSize=2 />
                                    {/each}
                                </div>
                                
                                
                                <details>
                                <summary class="subtitle">Cards at end of game: </summary>
                                    <div class="card_list">
                                            {#each p.cards.map(c => g.cards.find(cd => cd.id == c)).filter(c => c).sort((a,b) => byPlayCount(a,b)) as c}
                                                {#if $res.cards.find(cd => cd.id == c.id)}
                                                    <LogCard showFinalScores showStats clickable textSize=2 c={{...$res.cards.find(cd => cd.id == c.id), score: 0, ...c}} />
                                                {:else if $res.cards.find(cd => cd.name == c.name)}
                                                    (<LogCard showFinalScores showStats clickable textSize=2 c={{...$res.cards.find(cd => cd.name == c.name), score: 0, ...c}} />)
                                                {:else}
                                                    {c.name} ({c.id} – no longer in master spreadsheet)
                                                {/if}
                                            {/each}
                                    </div>
                                </details>
                            </div>-->
                            <div class="line"></div>
                            {#if p.bot}
                                Bot chart analysis:
                                <BotLog {p} />
                            {/if}
                            
                        {/each}
                    </div>
                    
                    <hr />
            {/each}
            {:catch e}
                Couldn't load game details ({e.message}). <button on:click={() => {games = games;}}>Retry</button>
            {/await}
         </TabPanel>   
         <TabPanel>
            {#await loadAllCampaigns()}
                Loading campaigns...
            {:then campaigns}
                {campaigns.length} campaigns logged so far ({campaigns.filter(c => c.ended).length} completed, {campaigns.filter(c => !c.ended).length} ongoing).
                {#each campaigns as c}
                    <CampaignSummary {c} showUsername={true} />
                {/each}
            {/await}
         </TabPanel>
         <TabPanel>
            <h2>Cards</h2>
            {#await ensureGameDetails(games)}
                Loading card data for {games.length} games...
            {:then}
            <div>
                <details open>
                    <summary>Location cards</summary>
                    <div class="subtitle">Most popular neutral locations:</div>
                    <div>Stat is number of times taken / number of games in which they came into the market</div>
                    <div class="card_list">
                        {#each analyseCards(games).locations.byPopularity as obj}
                            <LogCard customStat stat={obj.popularityString} clickable textSize=2 c={obj.card} />
                        {/each}
                    </div>
                </details>
                <details open>
                    <summary>Market cards</summary>
                    <div class="subtitle">Most popular market cards:</div>
                    <div>Stat is number of times taken / number of games in which they came into the market</div>
                    <div class="card_list">
                        {#each analyseCards(games).market.byPopularity as obj}
                            <LogCard customStat stat={obj.popularityString} clickable textSize=2 c={obj.card} />
                        {/each}
                    </div>
                </details>
                <details open>
                    <summary>Development order</summary>
                    <div>
                        For captain: <select bind:value={devCaptain} on:change={e => {devList = analyseCards(games).devs.byTime}}>
                            {#each captains(games, "no bot").map(c => c.name) as cap}
                                <option value={cap}>{cap}</option>
                            {/each}
                        </select>
                    </div>
                    <div>Stat is average turn in which the card was developed / number of games in which it was developed</div>
                    <div class="card_list">
                        {#each devList as obj}
                            {#if obj.card.deck == devCaptain}
                                <LogCard customStat stat={obj.avgString} clickable textSize=2 c={obj.card} />
                            {/if}
                        {/each}
                    </div>
                </details>
            </div>
            <div>
                <details open>
                    <summary>Card-by-card analysis</summary>
                    <div>
                        Filter:
                        <select bind:value={cardFilter}>
                            <option value={false}>All cards</option>
                            <option value="Common">Market cards</option>
                            <option value="Locations">Neutral locations</option>
                            <option value="Encounters">Encounters</option>
                            <option value="Incidents">Incidents</option>
                            {#each captains(games, "no bot").map(c => c.name) as cap}
                                <option value={cap}>{cap} deck</option>
                            {/each}
                        </select>
                    </div>
                    <details>
                        <summary class="subtitle">Card actions/activations</summary>
                        <div>(number is average plays / number of games in which it entered play)</div>
                        <div>Plays:</div>
                        <div class="card_list">
                            {#each analyseCards(games, cardFilter).plays.byMost as s}
                                {#if matchesCard(s.card, cardFilter)}
                                    <LogCard clickable customStat stat={`${s.avg.toFixed(1)}/${analyseCards(games).numGames[s.card.id]}`} textSize=2 c={s.card} />
                                {/if}
                            {/each}
                        </div>
                        <div>Activations:</div>
                        <div class="card_list">
                            {#each analyseCards(games, cardFilter).activations.byMost as s}
                                {#if matchesCard(s.card, cardFilter)}
                                    <LogCard clickable customStat stat={`${s.avg.toFixed(1)}/${analyseCards(games).numGames[s.card.id]}`} textSize=2 c={s.card} />
                                {/if}
                            {/each}
                        </div>
                        <div>Reactions:</div>
                        <div class="card_list">
                            {#each analyseCards(games, cardFilter).reactions.byMost as s}
                                {#if matchesCard(s.card, cardFilter)}
                                    <LogCard clickable customStat stat={`${s.avg.toFixed(1)}/${analyseCards(games).numGames[s.card.id]}`} textSize=2 c={s.card} />
                                {/if}
                            {/each}
                        </div>
                    </details>
                    <details>
                        <summary class="subtitle">Multi-use cards: options chosen</summary>
                        <div>(the number on each card is the number of games in which it entered play)</div>
                        <ul>
                            {#each analyseCards(games, cardFilter).summary.sort((a,b) => a.card.name.localeCompare(b.card.name)) as s}
                                {#if matchesCard(s.card, cardFilter)}
                                    {#if s.choices}
                                        <li>
                                            <LogCard clickable customStat stat={s.numGames} textSize=2 c={s.card} />:
                                            <ul>
                                                {#each Object.keys(s.choices) as o}
                                                    <li>{@html convert(o, true)}: <b>{s.choices[o]} times</b></li>
                                                {/each}
                                            </ul>
                                        </li>
                                    {/if}
                                {/if}
                            {/each}
                        </ul>
                    </details>
                    
                </details>
            </div>
            {:catch e}
                Couldn't load card data ({e.message}). <button on:click={() => {games = games;}}>Retry</button>
            {/await}
         </TabPanel>
        </Tabs>
    </div>
    <Preview force showImages={false} />
{/await}
{#if showLog}
    <div class="modal" style="max-height: 70vh;">
        <Log log={$state.log}/>
        <div>
            <button on:click={e => {showLog = false; resetStores('state'); }}>Close</button>
        </div>
    </div>
{/if}
<style>
    .pane {
        height: 70vh;
        width: 100vw;
        overflow: auto;
    }

    .card_list {
        display: flex;
        flex-wrap: wrap;
    }

    table {
        border: 1px solid white;
    }

    th {
        border-bottom: 1px solid white;
    }

    .center {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .table_label {
        display: flex;
        flex-direction: column;
        align-items: center;
        align-content: center;

    }
    
    .player {
        border: 0.5vmin solid white;
        padding: 1vmin;
        margin-top: 1vmin;
        margin-bottom: 1vmin;
    }

    .picard {
        background-color: darkblue;
    }
    
    .koloth {
        background-color: darkred;
    }

    .sisko {
        background-color: #7393B3;
    }

    .shran {
        background-color: darkcyan;
    }

    .sela {
        background-color: darkgreen;
    }

    .kirk {
        background-color: darkgoldenrod;
    }

    .rebner {
        background-color: plum;
        color: black;
    }

    .freeman {
        background-color: purple;
    }

    .player_title {
        font-weight: bold;
        font-size: 2.5vmin; 
        /*text-decoration: underline;*/
    }

    .title {
        font-weight: bold;
        font-size: 3vmin;
        text-decoration: underline;
        margin-bottom: 1vmin;
    }

    .subtitle {
        font-style: italic;
        font-size: 2vmin;
    }

    .basicinfo {
        font-style: italic;
    }

    .line {
        margin-top: 0.5vmin;
        margin-bottom: 0.5vmin;
        width: 100%;
        height: 2px;
        background-color: white;
    }

    table, th, td {
        border: 1px solid white;
        border-collapse: collapse;
        text-align: center;
    }

    .score_item {
        margin-left: 20px;
    }

    .modal {
		position: absolute;
		z-index: 200;
		/*left: 50%;
		top: 50%;*/
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
		padding: 3vmin;
		padding-bottom: 1vmin;
		/*transform: translate(-50%, -50%);*/
		max-height: 90vh;
        height: fit-content;
        width: fit-content;
		max-width: 90vw;
		min-width: 60vw;
		overflow: auto;
		background-color: grey;
		color: black;
		box-shadow: 0 0 5px 5px black; color: white;
	}


    .multiselect {
		--multiItemActiveBG: blue;
		--multiItemActiveColor: white;
		--multiItemBG: lightgrey;
		--itemHoverBG: blue;
		--itemHoverColor: white;
		--itemColor: black;
		display: inline-block;
		vertical-align: middle;
	}
</style>
